import { type IGlobalValues } from "helpers/GlobalValues";

/**
 * Reads a value off the `btJScriptGlobals` object the webforms master page inlines server-side.
 *
 * @deprecated Do not use in SPA-reachable code. As of ado-284707 every SPA call site reads the
 * `GlobalInfo` context or `helpers/globalContext/globalInfoSnapshot`. On a standalone SPA route
 * this trips the deprecation Proxy and logs a console error in non-prod.
 */
export function getGlobalValue<Key extends keyof IGlobalValues>(key: Key): IGlobalValues[Key] {
    return (globalThis as unknown as Window).btJScriptGlobals[key];
}
